import upgradeConfig from './upgradeConfig';

let moduleConfig = {
  /** 组件模板
  * topAndBottom , leftAndRight , table , leftChartPie , histogram , histogramAndLine , line
  * histogramAndStack , pie , bar , rosePie , proportionPie
  *
  * table 时配置 config 的属性：
  * {
  *   align:'left || right || center',  // 对齐方式
  *   border: border: '1 || bottom || top || left || right ',  // 边线
  *   more: true || false,  // 是否显示查看更多
  *   code: 'String', // 查看更多时的接口code
  *   title: 'String', // 查看更多时的标题
  *   code: 'String', // 查看城市下面的项目的接口code
  *   title: 'String', // 查看城市下的项目标题
  *   highlight: false || true // 是否高亮(false 为高亮，true 不高亮)
  *   showExecTime: false || true // 是否显示更新时间(false 为高亮，true 不高亮)
  *   isClick: false || true // 是否可以点击，false 为可点击 ， true 为不可点击
  * }
  *
  * histogramAndLine 中的config:{ showLine(折线图):[] }
  *
  */

  /**
   * 投资
   */
  // 投资概要_事业部
  'MB-TZ-S-TZGK': [{
    chartType: 'table', interfaceCode: 'TZGY_SYB_N', orgType: 'SYB',
    config: {
      align: 'left', border: '', subTitlt: true, showExecTime: true
    }
  }],

  // 投资概要_城市
  'MB-TZ-C-TZGK': [{
    chartType: 'table', interfaceCode: 'TZGY_CS_N', orgType: 'CITY',
    config: {
      align: 'left', border: '', subTitlt: true, showExecTime: true
    }
  }],

  // 拿地金额_事业部
  'MB-TZ-S-NDJE': [
    { chartType: 'histogramAndLine', interfaceCode: 'NDJE_SYB', orgType: 'SYB', config: { showLine: ['综合权益占比(按金额)'] } },
    {
      chartType: 'table', interfaceCode: 'NDJE_TOP5_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'NDJE_SYB_GCSNDJEQK', title: '各城市拿地金额情况', isClick: true },
        threePageConfig: { code: 'NDJE_SYB_GXMNDJEQK', title: '各项目拿地金额情况', orgType: 'CITY' }
      }
    }, // 拿地金额_TOP5_事业部
  ],

  //  拿地金额_城市
  'MB-TZ-C-NDJE': [
    { chartType: 'histogramAndLine', interfaceCode: 'NDJE_CS', orgType: 'CITY', config: { showLine: ['综合权益占比(按金额)'] } }, //拿地金额_城市
    {
      chartType: 'table', interfaceCode: 'NDJE_TOP5_CSZ', orgType: 'CITY',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'NDJE_CS_GXMNDJEQK', title: '各项目拿地金额情况', orgType: 'CITY' },
      }
    }, // 拿地金额_TOP5_城市
  ],

  // 拿地面积
  'MB-TZ-S-NDMJ': [
    { chartType: 'histogramAndLine', interfaceCode: 'NDMJ_SYB', orgType: 'SYB', config: { showLine: ['综合权益占比(按面积)'] } }, // 拿地面积_事业部
    {
      chartType: 'table', interfaceCode: 'NDMJ_TOP5_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'NDMJ_SYB_GCSNDMJQK', title: '各城市拿地面积情况', isClick: true },
        threePageConfig: { code: 'NDMJ_SYB_GXMNDMJQK', title: '各项目拿地面积情况', orgType: 'CITY' }
      }
    }, //拿地面积_TOP5_事业部
  ],
  'MB-TZ-C-NDMJ': [
    { chartType: 'histogramAndLine', interfaceCode: 'NDMJ_CSZ', orgType: 'CITY', config: { showLine: ['综合权益占比(按金额)'] } }, // 拿地面积_城市
    {
      chartType: 'table', interfaceCode: 'NDMJ_TOP5_CSZ', orgType: 'CITY',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'NDMJ_CS_GXMNDMJQK', title: '各项目拿地面积情况', orgType: 'CITY' }
      }, // 拿地面积_TOP5_城市
    }
  ],

  // 投资销售比
  'MB-TZ-S-TZXSB': [
    {
      chartType: 'customSalesRatio', interfaceCode: 'TZHHBQK_TZXSHKB_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'TZHHBQK_SYB_GCSTZQK', title: '各城市投资情况' }
      }
    }, // 投资后回本情况_投资销售比_事业部
  ],
  'MB-TZ-C-TZXSB': [
    {
      chartType: 'leftAndRight', interfaceCode: 'TZHHBQK_TZXSHKB_CSZ', orgType: 'CITY',
      config: { align: 'left', border: 'bottom' }
    }, // 投资后回本情况_投资销售比_城市
  ],

  // 拿地分析
  'MB-TZ-S-TZFX': [
    // TODO 测试 customLeftRightPie 组件
    { chartType: 'customLeftRightPie', interfaceCode: 'NDFX_SYB_NDGC', orgType: 'SYB' }, // 拿地分析_事业部_拿地构成
    {
      chartType: 'customTabsTable', interfaceCode: 'NDFX_SYB_TDYJL', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        tabsCode: ['NDFX_SYB_TDYJL', 'NDFX_SYB_HDB'],
        twoPageConfig: { code: 'NDFX_SYB_GCSTZFX', title: '各城市投资分析' },
        threePageConfig: { code: 'NDFX_SYB_GXMTZFX', title: '各项目投资分析', orgType: 'CITY' }
      }
    }, // 拿地分析_事业部_土地溢价率
  ],
  'MB-TZ-C-TZFX': [
    { chartType: 'customLeftRightPie', interfaceCode: 'NDFX_CSZ_NDGC', orgType: 'CITY', }, // 拿地分析_城市总_拿地构成
    {
      chartType: 'customTabsTable', interfaceCode: 'NDFX_CSZ_TDYJL', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true,
        tabsCode: ['NDFX_CSZ_TDYJL', 'NDFX_CSZ_HDB'],
        twoPageConfig: { code: 'NDFX_CSZ_GCSTZFX', title: '各城市投资分析', orgType: 'CITY' }

      }
    }, // 拿地分析_城市总_土地溢价率
  ],


  // 新增项目
  'MB-TZ-S-XZXM': [
    { chartType: 'customNewProject', interfaceCode: 'XZXM_SYB_CPBBQK', orgType: 'SYB' },// 新增项目__事业部_操盘、并表情况 TODO
    { chartType: 'histogram', interfaceCode: 'XZXM_SYB_DNMYXHXMS', orgType: 'SYB' },// 新增项目_事业部_当年每月新获项目数
    {
      chartType: 'table', interfaceCode: 'XZXM_SYB_TOP5_SYB', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'XZXM_SYB_GCSXZXMQK', title: '各城市新增项目情况' }
      }
    },// 新增项目_事业部_TOP5_事业部
  ],
  'MB-TZ-C-XZXM': [
    { chartType: 'customNewProject', interfaceCode: 'XZXM_CSZ_CPBBQK', orgType: 'CITY' },// 新增项目__城市总_操盘、并表情况 TODO
    { chartType: 'histogram', interfaceCode: 'XZXM_CSZ_DNMYXHXMS', orgType: 'CITY' },// 新增项目__城市总_新增项目情况
  ],

  /**
   * 资金
   */
  // 资金概要
  'MB-ZJ-S-ZJGY': [
    {
      chartType: 'table', interfaceCode: 'ZJ_ZJGY_SYB_N', orgType: 'SYB',
      config: { align: 'left', border: '', subTitlt: true, showExecTime: true }
    },//资金_资金概要_事业部
  ],
  'MB-ZJ-C-ZJGY': [
    {
      chartType: 'table', interfaceCode: 'ZJ_ZJGY_CS_N', orgType: 'CITY',
      config: { align: 'left', border: '', subTitlt: true, showExecTime: true, orgType: 'CITY' }
    },//资金_资金概要_城市
  ],

  // 资金余额
  'MB-ZJ-S-ZJYE': [
    {
      chartType: 'table', interfaceCode: 'ZJ_ZJYE_SYB', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'ZJ_ZJYE_GCSZJYE_SYB', title: '各城市资金余额情况', align: 'center', }
      }
    },// 资金_资金余额_事业部
  ],

  // 融资情况
  'MB-ZJ-S-RZQK': [
    {
      chartType: 'customFinancingTable', interfaceCode: 'ZJ_RZQK_SYB', orgType: 'SYB',
      config: { align: 'left', border: 'bottom' }
    },//资金_融资情况_事业部
    { chartType: 'histogram', interfaceCode: 'ZJ_RZQK_QYHRZYE_SYB', orgType: 'SYB' },//资金_融资情况_权益后融资余额_事业部
    {
      chartType: 'table', interfaceCode: 'ZJ_RZQK_TOP5_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'ZJ_RZQK_GCSRZQK_SYB', title: '各城市融资情况' }
      }
    },//资金_融资情况_TOP5_事业部
  ],
  'MB-ZJ-C-RZQK': [
    {
      chartType: 'customFinancingTable', interfaceCode: 'ZJ_RZQK_CS', orgType: 'CITY',
      config: { align: 'left', border: 'bottom' }
    },//资金_融资情况_城市
    { chartType: 'histogram', interfaceCode: 'ZJ_RZQK_QYHRZYE_CS', orgType: 'CITY' },//资金_融资情况_权益后融资余额_城市
  ],

  // 综合回款
  'MB-ZJ-S-ZHHK': [
    { chartType: 'histogramAndLine', interfaceCode: 'ZJ_ZHHK_QYHHKJE_SYB', orgType: 'SYB', config: { showLine: ['回款率'] } },//资金_综合回款_当年权益后回款金额走势图_事业部
    {
      chartType: 'table', interfaceCode: 'ZJ_ZHHK_TOP5_SYB', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'ZJ_ZHHK_GCSZHHKQK_SYB', title: '各城市综合回款情况', align: 'center', isClick: true },
        threePageConfig: { code: 'ZJ_ZHHK_GXMZHHKQK_SYB', title: '各项目综合回款情况', align: 'center', orgType: 'CITY' }
      }
    },//资金_综合回款_TOP5_事业部
    // TODO 点击城市未实现
  ],
  'MB-ZJ-C-ZHHK': [
    { chartType: 'histogramAndLine', interfaceCode: 'ZJ_ZHHK_QYHHKJE_CS', orgType: 'CITY', config: { showLine: ['回款率'] } },//资金_综合回款__权益后回款金额_城市
    {
      chartType: 'table', interfaceCode: 'ZJ_ZHHK_TOP5_CS', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'ZJ_ZHHK_GXMZHHKQK_CS', title: '各项目综合回款情况', orgType: 'CITY' },
      }
    },//资金_综合回款_TOP5_城市
  ],

  // 刚性支出
  'MB-ZJ-S-GXZC': [{ chartType: 'bar', interfaceCode: 'ZJ_GXZC_SYB', orgType: 'SYB' }],//资金_刚性支出_事业部

  /**
   * 收支
   */

  // 收支概要
  'MB-SZ-S-SZGY': [{
    chartType: 'table', interfaceCode: 'SZ_SZGY_SYB', orgType: 'SYB',
    config: { align: 'left', border: '', showExecTime: true }
  }],
  'MB-SZ-C-SZGY': [{
    chartType: 'table', interfaceCode: 'SZ_SZGY_CS', orgType: 'CITY',
    config: { align: 'left', border: '', showExecTime: true }
  }],

  // 现金流
  'MB-SZ-S-XJL': [{ chartType: 'histogram', interfaceCode: 'SZ_XJL_SYB', orgType: 'SYB' }],

  // 收入情况
  'MB-SZ-S-SRQK': [
    { chartType: 'histogramAndStack', interfaceCode: 'SZ_SRQK_SYB', orgType: 'SYB' }],

  // 负债情况
  'MB-SZ-S-FZQK': [
    { chartType: 'histogramAndLine', interfaceCode: 'SZ_FZQK_SYB', orgType: 'SYB', config: { showLine: ['净负债率', '资产负债率'] } }],

  // 利润情况
  'MB-SZ-S-LRQK': [
    { chartType: 'histogram', interfaceCode: 'SZ_LRQK_SYB', orgType: 'SYB' }],

  // 成长能力
  'MB-SZ-S-CZNL': [
    { chartType: 'line', interfaceCode: 'SZ_CZNL_SYB', orgType: 'SYB' }],

  // 有息负债情况
  'MB-SZ-S-YXFZQK': [
    { chartType: 'customDebtTopAndBottom', interfaceCode: 'SZ_YXFZQK_SYB_N', orgType: 'SYB' },
    { chartType: 'histogramAndLine', interfaceCode: 'SZ_YXFZQK_DNMYYXFZBQK_SYB_N', orgType: 'SYB', config: { showLine: ['有息负债占总负债比', '有息负债占总资产比'] } }
  ],

  // 费用情况
  'MB-SZ-S-FYQK': [
    { chartType: 'customCostTopAndBottom', interfaceCode: 'SZ_FYQK_SYB_N', orgType: 'SYB' },
    { chartType: 'histogram', interfaceCode: 'SZ_FYQK_DNGYFYQK_SYB_N', orgType: 'SYB' },
  ],


  /**
   * 供货
   */

  // 供货概要
  'MB-GH-S-GHGY': [
    {
      chartType: 'table', interfaceCode: 'GH_GHGY_SYB_N', orgType: 'SYB',
      config: { align: 'left', border: '', showExecTime: true }
    }],
  'MB-GH-C-GHGY': [
    {
      chartType: 'table', interfaceCode: 'GH_GHGY_CS_T', orgType: 'CITY',
      config: { align: 'left', border: '', showExecTime: true }
    }],

  // 项目供货情况
  'MB-GH-S-XMGH': [
    { chartType: 'customLeftRightGauge', interfaceCode: 'GH_BYGHQK', orgType: 'SYB' }, // 供货_项目供货情况
    {
      chartType: 'table', interfaceCode: 'GH_Bottom5_XMGHQK', orgType: 'SYB',
      config: {
        align: 'left', border: '', more: true, highlight: true,
        twoPageConfig: { code: 'GH_GXMGHQK_XMGHQK', title: '各项目供货情况项目' }
      }
    }, // 供货_Bottom5_项目供货情况_事业部
  ],
  'MB-GH-C-XMGHQK': [
    { chartType: 'customLeftRightGauge', interfaceCode: 'GH_BYGHQK_CS_T', orgType: 'CITY' }, // 供货_项目供货情况_城市
    {
      chartType: 'table', interfaceCode: 'GH_Bottom5_XMGHQK_CS_T', orgType: 'CITY',
      config: {
        align: 'left', border: '', more: true,
        twoPageConfig: { code: 'GH_GXMGHQK_XMGHQK_CS_T', title: '各项目供货情况项目', orgType: 'CITY' }
      }
    }, // 供货_Bottom5_项目供货情况_城市
  ],

  // 首开供货情况
  'MB-GH-S-SKGH': [
    { chartType: 'histogram', interfaceCode: 'GH_SKGHQK_SYB_T', orgType: 'SYB' },
    {
      chartType: 'table', interfaceCode: 'GH_SKGHQK_TOP5_SYB_T', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true, highlight: true,
        twoPageConfig: { code: 'GH_GXMSKGHQK_TOP5_SYB_T', title: '各项目首开供货情况', orgType: 'SYB', highlight: true }
      }
    },
  ],
  'MB-GH-C-SKGHQK': [
    { chartType: 'histogram', interfaceCode: 'GH_SKGHQK_CS_T', orgType: 'CITY' },
    {
      chartType: 'table', interfaceCode: 'GH_SKGHQK_TOP5_CS_T', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true, highlight: true,
        twoPageConfig: { code: 'GH_GXMSKGHQK_TOP5_CS_T', title: '各项目首开供货情况', orgType: 'CITY', highlight: true }
      }
    },
  ],

  // 未来供货情况
  'MB-GH-S-WLGH': [
    { chartType: 'histogram', interfaceCode: 'GH_WLGHJH_SYB_N', orgType: 'SYB' },
    {
      chartType: 'table', interfaceCode: 'GH_WLGHJH_TOP5_SYB_N', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'GH_GESWLGHJH_SYB_N', title: '各城市未来供货计划', isClick: true },
        threePageConfig: { code: 'GH_GXMWLGHJH_SYB_N', title: '各项目未来供货计划', orgType: 'CITY' }
      }
    },
  ],
  'MB-GH-C-WLGHQK': [
    { chartType: 'histogram', interfaceCode: 'GH_WLGHJH_CITY_T', orgType: 'CITY' },
    {
      chartType: 'table', interfaceCode: 'GH_WLGHJH_TOP5_CITY_T', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true, highlight: true,
        twoPageConfig: { code: 'GH_GXMLGHJH_CITY_T', title: '各项目未来供货计划', orgType: 'CITY', highlight: true }
      }
    },
  ],
  // 全年供货情况
  'MB-GH-S-QNGHQK': [

    { chartType: 'histogramAndLine', interfaceCode: 'GH_QNGHQK_SYB_T', orgType: 'SYB', config: { showLine: ['供货达成率'] } },
    {
      chartType: 'table', interfaceCode: 'GH_QNGHQK_TOP5_SYB_T', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'GH_GCSQNGHQK_T', title: '各城市供货情况', isClick: true },
        threePageConfig: { code: 'GH_GXMQNGHQK_SYB_T', title: '各项目全年供货情况', orgType: 'CITY' }
      }
    },
  ],
  'MB-GH-C-QNGHQK': [
    { chartType: 'histogramAndLine', interfaceCode: 'GH_QNGHQK_CITY_T', orgType: 'CITY', config: { showLine: ['供货达成率'] } },
    {
      chartType: 'table', interfaceCode: 'GH_QNGHQK_TOP5_CS_T', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'GH_GXMQNGHQK_CS_T', title: '各项目全年供货情况', orgType: 'CITY', highlight: true }
      }
    },
  ],



  /**
   * 签约
   */
  // 签约概要
  'MB-QY-S-QYGY': [
    {
      chartType: 'table', interfaceCode: 'QYGY_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: '', subTitlt: true, showExecTime: true
      }
    },
  ],
  'MB-QY-C-QYGY': [
    {
      chartType: 'table', interfaceCode: 'QYGY_CS', orgType: 'CITY',
      config: { align: 'left', border: '', subTitlt: true, showExecTime: true }
    },
  ],

  //签约日报
  'MB-QY-S-QYRB': [
    //  TODO 上下分栏
    { chartType: 'customDailyTopAndBottom', interfaceCode: 'QYRB_SYB', orgType: 'SYB' },
    {
      chartType: 'table', interfaceCode: 'QYRB_Top5_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'QYRB_GXMQYQK_SYB', title: '各项目签约情况' }
      }
    }
  ],
  'MB-QY-C-QYRB': [
    //  TODO 上下分栏
    { chartType: 'customDailyTopAndBottom', interfaceCode: 'QYRB_CS', orgType: 'CITY' },
    {
      chartType: 'table', interfaceCode: 'QYRB_Top5_CS', orgType: 'CITY',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'QYRB_GXMQYQK_CS', title: '各项目签约情况', orgType: 'CITY' }
      }
    }
  ],
  // 签约金额
  'MB-QY-S-QYJE': [
    {
      chartType: 'customContractAmount', interfaceCode: 'QYJE_QYQ_SYB', orgType: 'SYB',
      config: {
        before: {
          echart: 'QYJE_QYQ_SYB',
          top5: 'QYJE_QYQ_TOP5_SYB',
          tableConfig: {
            align: 'center', border: 'bottom', more: true,
            twoPageConfig: { code: 'QYJE_GCSQYQQYJEYTFB_SYB', title: '各城市权益前签约金额业态分布', align: 'center', isClick: true },
            threePageConfig: { code: 'QYJE_GXMQYQQYJEYTFB_SYB', title: '各项目权益前签约金额业态分布', align: 'center', orgType: 'CITY' }
          }
        },
        after: {
          echart: 'QYJE_QYH_SYB',
          top5: 'QYJE_QYH_TOP5_SYB',
          tableConfig: {
            align: 'center', border: 'bottom', more: true,
            twoPageConfig: { code: 'QYJE_GCSQYHQYJEYTFB_SYB', title: '各城市权益后签约金额业态分布', align: 'center', isClick: true },
            threePageConfig: { code: 'QYJE_GXMQYHQYJEYTFB_SYB', title: '各项目权益后签约金额业态分布', align: 'center', orgType: 'CITY' }
          }
        },
      }
    },
  ],
  'MB-QY-C-QYJE': [
    {
      chartType: 'customContractAmount', interfaceCode: 'QYJE_QYQ_CS', orgType: 'CITY',
      config: {
        before: {
          echart: 'QYJE_QYQ_CS',
          top5: 'QYJE_QYQ_TOP5_CS',
          tableConfig: {
            align: 'center', border: 'bottom', more: true,
            twoPageConfig: { code: 'QYJE_GXMQYQQYJEYTFB_CS', title: '各项目权益前签约金额业态分布', align: 'center', orgType: 'CITY' },
          }
        },
        after: {
          echart: 'QYJE_QYH_CS',
          top5: 'QYJE_QYH_TOP5_CS',
          tableConfig: {
            align: 'center', border: 'bottom', more: true,
            twoPageConfig: { code: 'QYJE_GXMQYHQYJEYTFB_CS', title: '各项目权益后签约金额业态分布', align: 'center', orgType: 'CITY' },
          }
        },
      }
    },
  ],
  // 达成率
  'MB-QY-S-DCL': [
    { chartType: 'histogramAndLine', interfaceCode: 'QY_DCL_SYB', orgType: 'SYB', config: { showLine: ['年度达成率'] } },
    {
      chartType: 'table', interfaceCode: 'QY_DCL_Top5_SYB', orgType: 'SYB',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'QY_DCL_GCSQYDCQK_SYB', title: '各城市签约达成情况', align: 'center', isClick: true },
        threePageConfig: { code: 'QY_DCL_GXMQYDCQK_SYB', title: '各项目签约达成情况', align: 'center', orgType: 'CITY' }
      }
    },
  ],
  'MB-QY-C-DCL': [
    { chartType: 'histogramAndLine', interfaceCode: 'QY_DCL_CS', orgType: 'CITY', config: { showLine: ['年度达成率'] } },
    {
      chartType: 'table', interfaceCode: 'QY_DCL_Top5_CS', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'QY_DCL_GXMQYDCQK_CS', title: '各项目签约达成情况', orgType: 'CITY' }
      }
    },
  ],

  // 签约套数
  'MB-QY-S-QYTS': [
    { chartType: 'histogramAndStack', interfaceCode: 'QYTS_SYB', orgType: 'SYB' },
    {
      chartType: 'table', interfaceCode: 'QYTS_TOP5_SYB', orgType: 'SYB',
      config: {
        align: 'left', border: 'bottom', more: true,
        twoPageConfig: { code: 'QYTS_GCSQYXMFYTSJ_SYB', title: '各城市签约套数分业态数据', isClick: true },
        threePageConfig: { code: 'QYTS_GXMQYXMFYTSJ_SYB', title: '各项目签约套数分业态数据', orgType: 'CITY' }
      }
    },
  ],
  'MB-QY-C-QYTS': [
    { chartType: 'histogramAndStack', interfaceCode: 'QYTS_CS', orgType: 'CITY' },
    {
      chartType: 'table', interfaceCode: 'QYTS_TOP5_CS', orgType: 'CITY',
      config: {
        align: 'center', border: 'bottom', more: true,
        twoPageConfig: { code: 'QYTS_GXMQYXMFYTSJ_CS', title: '各城市签约套数分业态数据', orgType: 'CITY' }
      }
    },
  ],

  /**
  * 风控
  */
  // 风控概要
  'MB-FK-S-FKGY': [
    {
      chartType: 'table', interfaceCode: 'FKQDKB_FKGY_SYB', orgType: 'SYB',
      config: { align: 'left', border: '', showExecTime: true }
    },
  ],
  'MB-FK-C-FKGY': [
    {
      chartType: 'table', interfaceCode: 'FKQDKB_FKGY_CSGS', orgType: 'CITY',
      config: { align: 'left', border: '', showExecTime: true }
    },
  ],
  // 渠道成交风险
  'MB-FK-S-QDCJFX': [
    { chartType: 'customRiskAnalysis', interfaceCode: 'FKQDKB_DNMYQDCJFXFX_SYB', orgType: 'SYB', config: { showLine: ['风险比例'] } },
    { chartType: 'customRiskAnalysis', interfaceCode: 'FKQDKB_DNGCSQDCJFXFX_SYB', orgType: 'SYB', config: { showLine: ['风险比例'] } },
    {
      chartType: 'customRiskControl', interfaceCode: 'FKQDKB_GCSCJKHSJ_SYB', orgType: 'SYB',
      config: { align: 'left', border: '', twoPageCode: 'FKQDKB_SHGXMCJKHSJ_SYB', threePageCode: 'FKQDKB_GQDCJKHSJ_SYB', orgType: 'CITY' }
    },
  ],

  'MB-FK-C-QDCJFX': [
    { chartType: 'customRiskAnalysis', interfaceCode: 'FKQDKB_DNMYQDCJFXFX_CS', orgType: 'CITY', config: { showLine: ['风险比例'] } },
    {
      chartType: 'customRiskControl', interfaceCode: 'FKQDKB_DNGCSQDCJFXFX_CS', orgType: 'CITY',
      config: { align: 'left', border: '', twoPageCode: 'FKQDKB_GCSCJKHSJ_CS', threePageCode: '', orgType: 'PROJECT' }
    },
  ],

}

const mergeModuleConfig = {
  ...moduleConfig,
  ...upgradeConfig
}

export default mergeModuleConfig
